import { DRAWER_HEIGHT } from '../constants';

interface CombinationDrawers {
  combo: number[]; // combination valid (sum(entries) < height)
  total: number; // sum(entries)
  diffAvg: number; // total diff between entrie
  rest: number; // height - total
}

export function getStandardHeight() {
  //Todo: get drawer height from pieces instead of a constant
  return DRAWER_HEIGHT;
}

export function combine(comboOptions: any[], comboLength: any) {
  /**
   * Combine with repetition
   */
  if (comboLength === 1) {
    return comboOptions.map(comboOption => [comboOption]);
  }

  const combos: any[] = [];

  comboOptions.forEach((currentOption, optionIndex) => {
    const smallerCombos = combine(
      comboOptions.slice(optionIndex),
      comboLength - 1,
    );

    smallerCombos.forEach((smallerCombo: any) => {
      // @ts-ignore
      combos.push([currentOption].concat(smallerCombo));
    });
  });

  return combos;
}

function getAverageDiff(combo: number[], sumCombo: number) {
  const average = sumCombo / combo.length;
  let totalDiff = 0;
  for (const entry of combo) {
    // Use logarithmic function in order sort the minimum diff with the avg
    totalDiff += Math.pow(entry - average, 2);
  }

  return totalDiff;
}

export function findCombinations(
  height: number,
  count: number,
): number[] | undefined {
  /**
   * Compute all combinations of drawers
   * Standard size: [100, 135, 170, 200, 270, 370]
   */
  const standardsSizes = getStandardHeight();

  const validCombos: CombinationDrawers[] = [];

  const combos = combine(
    standardsSizes.filter(item => item <= height),
    count,
  );
  for (const combo of combos) {
    const sumCombo = combo.reduce(
      (sum: number, current: number) => sum + current,
      0,
    );
    if (sumCombo <= height) {
      const differenceAverage = getAverageDiff(combo, sumCombo);
      validCombos.push({
        combo: combo,
        total: sumCombo,
        diffAvg: differenceAverage,
        rest: height - sumCombo,
      });
    }
  }

  let result: number[] = [];
  if (validCombos.length > 0) {
    validCombos.sort(function(a, b) {
      return a['rest'] - b['rest'] || a['diffAvg'] - b['diffAvg'];
    });
    result = validCombos[0].combo;
    result[0] += validCombos[0].rest;
    result.sort((a, b) => b - a);
    return result;
  }
}

export function getDrawersCount(height: number, previousDrawerCount: number) {
  /**
   * Get the number of drawer we allocate when the height of shelf change
   * It's base of the previous drawer count, we try to stay close to it
   * It's better to not sell 370mm drawer because it's too heavy, so, it's split in two drawers
   */
  if (height <= 170) return 1;
  if (previousDrawerCount === 1) {
    if (height <= 270) return 1;
    return 2;
  } else if (previousDrawerCount === 2) {
    if (height <= 170) return 1;
    return 2;
  } else if (previousDrawerCount === 3) {
    if (height <= 270) return 2;
    if (height < 370) return 2;
    return 3;
  } else if (previousDrawerCount === 4) {
    if (height <= 270) return 2;
    if (height > 370) return 4;
    return 3;
  }

  throw new Error('Should get drawer count');
}

export function getCombo(
  previousCombo: number[],
  height: number,
): number[] | undefined {
  const newDrawersCount = getDrawersCount(height, previousCombo.length);
  const previousHeight = previousCombo.reduce(
    (sum, current) => sum + current,
    0,
  );

  if (height === previousHeight) return previousCombo;

  return findCombinations(height, newDrawersCount);
}
